import PropTypes from "prop-types";
import React from "react";
import {styled} from "@mui/material/styles";

export default function CharacterCounter({value = '', min = 0, max = 0, ...props}) {
    const valueLength = ~~value?.length;

    // if (max > 0 && valueLength < max) {
        return (
            <Container>
                {valueLength}/{max} characters
            </Container>
        )
    // }

    return null;
}

CharacterCounter.propTypes = {
    value: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
};

const Container = styled('div')({
    opacity: 0.3,
    position: 'absolute',
    bottom: '15px',
    right: '15px',
    fontSize: '13px',
});
